import { PropsWithChildren } from 'react';

import Drawer from './Drawer';

interface Props {
  title: string;
  subtitle: string;
  open: boolean;
  onCancel: () => void;
}

const FilterDrawer = ({ title, subtitle, open, onCancel, children }: PropsWithChildren<Props>) => (
  <Drawer
    title={title}
    subtitle={subtitle}
    open={open}
    onClose={onCancel}
    PaperProps={{ sx: { width: { xs: '100%', sm: 680 }, maxWidth: '100vw' } }}
  >
    {children}
  </Drawer>
);

export default FilterDrawer;
